<!-- 考试 -->
<template>
  <div>
    <div class="go_exam">
      <el-button type="primary" @click="goExam">开始考试</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="80%">
      <span v-html="str"></span>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
    <!--    试卷列表-->
    <el-dialog
      title="选择"
      :visible.sync="examDialog"
      width="85%">
      <div>
        <div v-for="(item, index) in examRan" :key="index" class="examListx">
          <div>{{ item.name }}</div>
          <div>
            <el-button @click="startExam(item)" size="small" type="primary">开始考试</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      testCard: [],
      score: '',
      total: -1,
      // 倒计时
      hour: '',
      minute: '',
      second: '',
      promiseTimer: '',
      str: '',
      dialogVisible: false,
      examDialog: false,
      examRan: []
    }
  },
  mounted () {
  },
  methods: {
    // 进入考试详情页
    goExam () {
      if (this.gmdss.station_id !== 29) {
        let str = ''
        let canTakeTheExam = false
        if (this.gmdss.mustLearnVideo > 0) {
          str = '当前还有 ' + (this.gmdss.mustLearnVideo) + ' 个视频未学习'
          canTakeTheExam = true
        }
        let bookNumber = this.gmdss.requiredData.basicsUnread
        if (bookNumber > 0) {
          str += '<br>当前还有 ' + bookNumber + ' 份书本未阅读'
          canTakeTheExam = true
        }
        if (this.gmdss.requiredData.statutesUnread > 0) {
          str += '<br>当前还有 ' + this.gmdss.requiredData.statutesUnread + ' 项法规未阅读'
          canTakeTheExam = true
        }
        if (canTakeTheExam) {
          this.dialogVisible = true
          // this.$alert(str, '提示', {
          //   confirmButtonText: '确定',
          //   dangerouslyUseHTMLString: true
          // })
          this.str = str
          return
        }
      }
      this.RanExam()
      this.examDialog = true
    },
    startExam (row) {
      let id = row.id
      this.examDialog = false
      this.$router.push({name: 'exam', params: {id: id}})
    },
    RanExam () {
      let msg = {}
      msg.id = window.$gmdss.user_info.station_id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.RanExamFn
      sendData.vm = this
      req.Post('exam/RanExam', sendData)
    },
    RanExamFn (data) {
      if (data.err_code !== 0) {
        return
      }
      this.examRan = data.result
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.go_exam {
  width: 100%;
  text-align: center;
  margin-top: 20rem;
}

.examListx {
  display: flex;
  justify-content: space-between;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/comment.vue